'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInteger = exports.findIndex = undefined;

var _polyfills = require('./polyfills');

var findIndex = exports.findIndex = function findIndex(array, predicate) {
  var firstIndex = null;

  array.forEach(function (item, index) {
    if (predicate(item) && firstIndex === null) {
      firstIndex = index;
    }
  });

  return firstIndex;
};

var isInteger = exports.isInteger = function isInteger(value) {
  return (0, _polyfills.NumberIsInteger)(value);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/helpers.js
// module id = 468
// module chunks = 3 4 5